import React, {useContext} from "react";
import AuthViewModel from "../viewModel";
import {Box, ButtonRow, Title} from "../styles";
import Button from "components/Button";
import {LOGIN} from "constants/path";

function Confirmation() {
  const {navigate} = useContext(AuthViewModel.Context);
  return (
    <Box>
      <Title>Successfully Reset Password</Title>
      <ButtonRow>
        <Button onClick={() => navigate(LOGIN)}>Log in</Button>
      </ButtonRow>
    </Box>
  )
}

export default AuthViewModel.withProvider(Confirmation);
